import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBriefcase,
  faHandshake,
  faLightbulb,
  faLocationDot,
  faUserGroup,
  faUserShield
} from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import backgroundImage from '../Images/fundoteambuilding.png';
import '../CSS/Despedidas.css';

const TeamBuildingsPT = () => {
  return (
    <div className="er-partyPage">
      <section className="er-partyHero" aria-label="Team buildings">
        <img src={backgroundImage} alt="" className="er-partyHeroImg" />
        <div className="er-partyHeroOverlay">
          <div className="er-partyHeroInner">
            <div className="er-partyBadge">Cooperação • Estratégia • Diversão</div>

            <h1 className="er-partyTitle">
              Team <span className="er-partyTitleAccent">Buildings</span>
            </h1>

            <p className="er-partyLead">Fortalece a tua equipa!</p>
            <p className="er-partyText">
              Junta a equipa num desafio imersivo que promove comunicação, confiança e resolução de problemas —
              com adrenalina e momentos para reforçar o espírito de grupo.
            </p>

            <div className="er-partyCtas">
              <a
                className="er-partyCtaPrimary"
                href="https://wa.me/351934403133"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faWhatsapp} />
                Falar connosco
              </a>
            </div>
          </div>

          <div className="er-partyHeroCards">
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faHandshake} className="er-partyHeroCardIcon" />
              <h2 className="er-partyHeroCardTitle">Trabalho em equipa</h2>
              <p className="er-partyHeroCardText">
                Atividades pensadas para fortalecer a cooperação desde o primeiro minuto.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faLightbulb} className="er-partyHeroCardIcon" />
              <h2 className="er-partyHeroCardTitle">Estratégia e criatividade</h2>
              <p className="er-partyHeroCardText">
                Enigmas para testar comunicação, liderança e resolução de problemas.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faBriefcase} className="er-partyHeroCardIcon" />
              <h2 className="er-partyHeroCardTitle">Impacto real</h2>
              <p className="er-partyHeroCardText">
                Uma experiência divertida com resultados que passam para o dia a dia da equipa.
              </p>
            </article>
          </div>

          <div className="er-partyHeroCards">
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faUserGroup} className="er-partyFeatureIcon" />
              <h3 className="er-partyHeroCardTitle">Para todas as equipas</h3>
              <p className="er-partyFeatureText">
                Adaptamo-nos ao tamanho e aos objetivos da vossa equipa.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faLocationDot} className="er-partyFeatureIcon" />
              <h2 className="er-partyHeroCardTitle">Localização top</h2>
              <p className="er-partyFeatureText">
                No coração de Bragança, fácil de chegar e ideal para um evento de empresa.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faUserShield} className="er-partyFeatureIcon" />
              <h3 className="er-partyHeroCardTitle">Equipa dedicada</h3>
              <p className="er-partyFeatureText">
                Apoio antes, durante e depois do jogo para tudo correr sem stress.
              </p>
            </article>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TeamBuildingsPT;
